import type { FlowException, StageGlyph } from '@interfaces/IFlowView';
import { ArrowRightIcon, WarningTriangleIcon } from '@utils/icons';
import styles from './ExceptionLayer.module.css';

type IExceptionLayerProps = {
  title: string;
  openLabel: string;
  stageLabel: string;
  exceptions: FlowException[];
  activeStageKey: StageGlyph;
  onSelect: (key: StageGlyph) => void;
};

export function ExceptionLayer({
  title,
  openLabel,
  stageLabel,
  exceptions,
  activeStageKey,
  onSelect,
}: IExceptionLayerProps) {
  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <div className={styles.heading}>
          <span className={styles.glyphBox}>
            <WarningTriangleIcon size={16} />
          </span>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <span className={styles.count}>{openLabel}</span>
      </header>

      <ul className={styles.list}>
        {exceptions.map((ex) => (
          <li key={ex.id}>
            <button
              type="button"
              className={styles.exception}
              data-severity={ex.severity}
              data-active={ex.stageKey === activeStageKey}
              onClick={() => onSelect(ex.stageKey)}
            >
              <div className={styles.exceptionHead}>
                <span className={styles.exceptionDot} aria-hidden />
                <span className={styles.exceptionTitle}>{ex.title}</span>
              </div>
              <p className={styles.exceptionBody}>{ex.body}</p>
              <div className={styles.exceptionFoot}>
                <ArrowRightIcon size={12} />
                <span>
                  {stageLabel}: {ex.stageLabel}
                </span>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
